import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-background py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-113" data-mp="1iwcxjc03p0fu">
      <div className="mx-auto max-w-6xl px-4" data-id="element-114" data-mp="1dxji3e196zd1">
        <SectionHeading id="modules-title" data-id="element-115" data-mp="1dunhtj1xnylf">The {totalVolumes} <span className="text-accent" data-id="element-116" data-mp="2bj7ew01mfjp3">Professional Volumes</span></SectionHeading>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-117" data-mp="26kw49n3i555t">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.3,
            delay: index % 3 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-2xl border border-primary/40 bg-surface p-6 shadow-glow" data-id="element-118" data-mp="21nvx18ux1wd4" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-119" data-mp="1ntk2gd96sdot">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary text-foreground shadow-[0_0_14px_rgb(var(--color-primary)/0.6)]" data-id="element-120" data-mp="18xube0p59ad8">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-121" data-mp="104qz3vq8j3k6" />
                  </span>
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-primary-strong" data-id="element-122" data-mp="14vh6tfm4vii1">Volume {module.number}</p>
                </div>
                <h3 className="mt-4 text-lg font-bold leading-tight text-foreground" data-id="element-123" data-mp="q7mcjush962u">{module.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-124" data-mp="v6fsruz5fb6p">{module.summary}</p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}